webpackJsonp([35783957827783],{

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Code = function Code(_ref) {
	    var code = _ref.code;
	    return _react2.default.createElement(
	        'p',
	        { className: 'code' },
	        code
	    );
	};
	
	exports.default = Code;
	module.exports = exports['default'];

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _syntax = __webpack_require__(73);
	
	var _syntax2 = _interopRequireDefault(_syntax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Hello Developers! \xA0',
	      _react2.default.createElement('i', { className: 'em em-wave' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Let\'s help you submit your first Pull Request.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Once your pull request is being merged, your profile will be visible in the ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/submissions/' },
	        'Submissions '
	      ),
	      'section of this page. For this exercise you\'ll be adding a new entry to the source code of this website with your profile details. Excited? ',
	      _react2.default.createElement('i', { className: 'em em-grinning_face_with_star_eyes' }),
	      ' let\'s begin!'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Step 1'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Goto the ',
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', href: 'https://github.com/saimanoj75/First-Commit' },
	        ' GitHub repository '
	      ),
	      ' of this project and fork the project to your account. ',
	      _react2.default.createElement('i', { className: 'em em-knife_fork_plate' }),
	      'Click on the fork button on the top right corner of the repository page to do it. Once done, GitHub will take you to the forked copy in your account.',
	      _react2.default.createElement(_syntax2.default, { code: 'https://github.com/saimanoj75/First-Commit' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Step 2'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Clone the forked repository to your local machine. Click on the big green button saying "Clone or download" and copy the https url of your repository. Fire up the terminal (on linux systems ctrl+alt+t. on Windows open the ',
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', href: 'https://git-scm.com/download/win' },
	        'Git-bash'
	      ),
	      ' ) navigate to your desired directory and type the following command. Replace the link with the clone URL of your repository and hit Enter.',
	      _react2.default.createElement(_syntax2.default, { code: 'git clone https://github.com/YOUR_USERNAME/First-Commit.git' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Step 3'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Let\'s start working on the changes required now! First cd into the cloned folder by typing the following command.',
	      _react2.default.createElement(_syntax2.default, { code: 'cd First-Commit' }),
	      'Now, Before jumping in to the code, make sure you\'re working on a different branch and not in master. To create a new branch, from the terminal inside your current project directory type the following command.',
	      _react2.default.createElement(_syntax2.default, { code: 'git branch YOUR_USERNAME-profile' }),
	      'Replace the ',
	      _react2.default.createElement(
	        'i',
	        null,
	        'YOUR_USERNAME'
	      ),
	      ' with your GitHub username or you can give any name to your branch which describes the purpose of the branch. Since here we\'re adding your profile, we\'ll simply give the name of the branch as above. eg: ',
	      _react2.default.createElement(
	        'i',
	        null,
	        'git branch haxzie-profile'
	      ),
	      '. Once you have created the new branch we\'ll change the current brach from master to your newly created branch. Execute the following command on your terminal.',
	      _react2.default.createElement(_syntax2.default, { code: 'git checkout YOUR_BRANCH_NAME' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Step 4'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In your ',
	      _react2.default.createElement('i', { className: 'em em-card_file_box' }),
	      ' file manager/terminal navigate to the downloaded repo. Open the sub-directory ',
	      _react2.default.createElement('i', { className: 'em em-file_folder' }),
	      _react2.default.createElement(
	        'b',
	        null,
	        'src/profiles/'
	      ),
	      '. and create a new ',
	      _react2.default.createElement(
	        'b',
	        null,
	        '.md'
	      ),
	      ' file with your username as the filename with ',
	      _react2.default.createElement(
	        'b',
	        null,
	        '.md'
	      ),
	      ' extension.',
	      _react2.default.createElement('br', null),
	      'It should look like ',
	      _react2.default.createElement(
	        'b',
	        null,
	        'YOUR_USER_NAME.md'
	      ),
	      ' ',
	      _react2.default.createElement(
	        'i',
	        null,
	        'eg: saimanoj75.md '
	      ),
	      _react2.default.createElement('br', null),
	      'Open this file in your favourite editor and fill the details as below in the frontmatter of the markdown file.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('i', { className: 'em em-page_facing_up' }),
	      _react2.default.createElement(
	        'i',
	        null,
	        'YOUR_USER_NAME.md'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'code' },
	        '---',
	        _react2.default.createElement('br', null),
	        'username: YOUR_USER_NAME',
	        _react2.default.createElement('br', null),
	        'fullname: YOUR_FULL_NAME',
	        _react2.default.createElement('br', null),
	        '---'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Donot forget that the hyphens "---" are also part of the file. Once you finish adding the content, save the file.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Step 5'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Commit the changes with a suitable commit message.',
	      _react2.default.createElement('i', { className: 'em em-white_check_mark' }),
	      ' First we need to stage all the changes we made. Open the terminal inside the project directory and execute following commands.',
	      _react2.default.createElement(_syntax2.default, { code: 'git add filename' }),
	      'The above command stages all the changes, now lets commit it with a suitable message.',
	      _react2.default.createElement(_syntax2.default, { code: 'git commit -m "YOUR_COMMIT_MESSAGE"' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Step 6'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Let\'s push the changes to your repository!',
	      _react2.default.createElement('i', { className: 'em em-arrow_up' }),
	      ' execute the following command to push all the changes to the forked copy in your GitHub account.',
	      _react2.default.createElement(_syntax2.default, { code: 'git push -u origin YOUR_BRANCH_NAME' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Step 7'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Now, open your web browser and goto the ',
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', href: 'https://github.com/saimanoj75/First-Commit' },
	        ' original repository on GitHub'
	      ),
	      '. If your changes has been pushed to your forked copy, You\'ll be able to see an option saying "New Pull Request" in the original repository. Click on the option, one next page choose the master branch of the main repo against your created-branch name ( choose your branch name we created and not master). the click on create pull request. Once you fill in the commit message and comment click on submit pull request. ',
	      _react2.default.createElement('br', null),
	      'and you are all done! ',
	      _react2.default.createElement('i', { className: 'em em-confetti_ball' }),
	      ' Wait for a reviewer to review your file and merge it to the master. Once its been successfully merged, your profile will be visible in the submissions tab. ',
	      _react2.default.createElement('i', { className: 'em em-trophy' })
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-715fd1fbc228ea8acc03.js